function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st60{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st61{fill:#E30613;}\r\n\t.st62{fill:none;}\r\n\t.st63{font-family:'ArialMT';}\r\n\t.st64{font-size:34px;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("line", {
  className: "st60",
  x1: 5,
  y1: 306.7,
  x2: 19.7,
  y2: 306.7
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  className: "st60",
  x1: 795.1,
  y1: 9.3,
  x2: 809.7,
  y2: 9.3
});

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st61",
  points: "238.8,160.8 278.9,230.3 100.4,230.3 170.8,108.4 189.7,75.7 198.9,91.7 198.9,91.7 183.2,118.8  127.2,215.9 252.1,215.9 208.6,140.4 208.4,140.7 181.7,184 213.8,183.5 214,183.5 223.5,199.3 153.5,199.9 153.4,199.9  199.1,124 199.2,124 208.4,108.1 208.4,108.1  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M311.6,102.6h10.2v70.3h33.7v8.5h-43.9L311.6,102.6L311.6,102.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422.6,181.5l-0.8-7.1h-0.4c-3.2,4.4-9.2,8.4-17.3,8.4c-11.5,0-17.3-8.1-17.3-16.3c0-13.7,12.2-21.2,34-21.1v-1.2 c0-4.7-1.3-13.1-12.9-13.1c-5.3,0-10.8,1.6-14.7,4.2l-2.3-6.8c4.7-3,11.5-5,18.6-5c17.3,0,21.5,11.8,21.5,23.2v21.2 c0,4.9,0.2,9.7,0.9,13.6L422.6,181.5L422.6,181.5z M421.1,152.6c-11.2-0.2-24,1.8-24,12.8c0,6.7,4.4,9.8,9.7,9.8 c7.4,0,12.1-4.7,13.7-9.5c0.4-1.1,0.6-2.2,0.6-3.3L421.1,152.6L421.1,152.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M472,181.5c0.2-3.9,0.5-9.6,0.5-14.6V98.4h10.2V134h0.2c3.6-6.3,10.2-10.4,19.3-10.4c14,0,24,11.7,23.9,28.9 c0,20.2-12.8,30.3-25.4,30.3c-8.2,0-14.7-3.2-19-10.6h-0.4l-0.5,9.4L472,181.5L472,181.5z M482.6,158.8c0,1.3,0.2,2.6,0.5,3.7 c2,7.1,8,12.1,15.4,12.1c10.8,0,17.2-8.8,17.2-21.8c0-11.3-5.9-21.1-16.8-21.1c-7,0-13.6,4.8-15.7,12.6c-0.2,1.2-0.6,2.6-0.6,4.2 V158.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M615,152.7c0,20.9-14.5,30.1-28.2,30.1c-15.3,0-27.1-11.2-27.1-29.1c0-19,12.4-30.1,28.1-30.1 C604,123.6,615,135.4,615,152.7z M570.1,153.3c0,12.4,7.1,21.8,17.2,21.8c9.8,0,17.2-9.2,17.2-22c0-9.6-4.8-21.8-17-21.8 C575.4,131.3,570.1,142.5,570.1,153.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M652.8,142.5c0-6.7-0.1-12.4-0.5-17.7h9l0.4,11.1h0.5c2.6-7.6,8.8-12.4,15.7-12.4c1.2,0,2,0.1,2.9,0.4v9.7 c-1.1-0.2-2.1-0.4-3.5-0.4c-7.3,0-12.4,5.5-13.8,13.2c-0.2,1.4-0.5,3-0.5,4.8v30.2h-10.2L652.8,142.5L652.8,142.5z"
})));

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "st62",
  points: "756.1,267 290.1,267 292.1,200 758.1,200 "
});

var _ref7 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 292.0498 224.1148)",
  className: "st63 st64"
}, "Development &amp; Technology");

var SvgLaborLogo = function SvgLaborLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 820 312",
    style: {
      enableBackground: "new 0 0 820 312"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLaborLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/laborLogo.05a324c0.svg";
export { ForwardRef as ReactComponent };